import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell,
} from 'recharts';
import { MarketEmptyState } from './MarketEmptyState';

const BAR_COLOR = '#C9A84C';
const BAR_COLOR_LOW_SAMPLE = 'rgba(201,168,76,0.35)';
const GRID_COLOR = 'rgba(255,255,255,0.08)';
const TEXT_COLOR = '#94A3B8';

function ChartTooltip({ active, payload, valueFormatter }) {
  if (!active || !payload || !payload.length) return null;
  const point = payload[0].payload;
  return (
    <div className="mk-chart-tooltip">
      <div className="mk-chart-tooltip-title">{point.label}</div>
      <div className="mk-chart-tooltip-value">{valueFormatter ? valueFormatter(point.value) : point.value}</div>
      {typeof point.sampleSize === 'number' && (
        <div className="mk-chart-tooltip-sample">
          {point.sampleSize} settled runners{!point.sampleOk ? ' — small sample' : ''}
        </div>
      )}
    </div>
  );
}

/**
 * Horizontal bar chart — used for jockey/trainer leaderboards where names
 * are long. Bars below the minimum sample size render dimmed.
 * @param {Array} data - [{ label, value, sampleSize, sampleOk }]
 */
export const MarketHorizontalBarChart = ({
  data, valueFormatter = (v) => v,
  emptyMessage = 'More settled races are needed before jockey/trainer rankings become reliable.',
  height,
}) => {
  const hasData = Array.isArray(data) && data.length > 0;
  if (!hasData) {
    return <MarketEmptyState icon="🏇" message={emptyMessage} />;
  }

  const chartHeight = height || Math.max(160, data.length * 36);

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart data={data} layout="vertical" margin={{ top: 4, right: 24, left: 0, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID_COLOR} horizontal={false} />
        <XAxis type="number" tick={{ fill: TEXT_COLOR, fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={valueFormatter} />
        <YAxis
          dataKey="label" type="category" tick={{ fill: TEXT_COLOR, fontSize: 12 }}
          axisLine={false} tickLine={false} width={110}
        />
        <Tooltip cursor={{ fill: 'rgba(255,255,255,0.04)' }} content={<ChartTooltip valueFormatter={valueFormatter} />} />
        <Bar dataKey="value" radius={[0, 6, 6, 0]} maxBarSize={20}>
          {data.map((entry, idx) => (
            <Cell key={idx} fill={entry.sampleOk === false ? BAR_COLOR_LOW_SAMPLE : BAR_COLOR} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MarketHorizontalBarChart;
